import { render } from "./HowToPlay.vue?vue&type=template&id=047f1a2c&scoped=true&ts=true"
import script from "./HowToPlay.vue?vue&type=script&lang=ts"
export * from "./HowToPlay.vue?vue&type=script&lang=ts"

import "./HowToPlay.vue?vue&type=style&index=0&id=047f1a2c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047f1a2c"]])

export default __exports__